export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/util/eventConsts.js
// module id = 2297
// module chunks = 2